export default "__VITE_ASSET__BQYpUGrU__"